import type { Environment } from './environment.model';

/**
 * Development environment configuration
 * Used when running `ng serve` or building with `--configuration development`
 */
export const environment: Environment = {
  production: false,
  apiBase: 'https://api.irc.prg-dev.com/api/v1',
  fileBase: 'files',
  maxCacheSize: 1000,
  auth: {
    issuer: 'https://id.irc.prg-dev.com',
    clientId: 'b016ce7696c4499d0105',
    showDebugInformation: true,
  },
};
